import React from "react"
import {Helmet} from "react-helmet-async"
import { useStaticQuery, graphql } from "gatsby"


function Seo({ description, title, keywords}) {
    const { site } = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            name
            title
            description
            author
            viewport
            abstract
            identifierUrl
            revisitAfter
            keywords
            author
            language
            copyright
            robots
            siteUrl
          }
        }
      }
    `
    );
    const metaDescription = description !== "" ? description : site.siteMetadata.description;
    const metaTitle = title !== "" ? title : site.siteMetadata.title;
    const metaKeywords = keywords !== "" ? keywords : site.siteMetadata.keywords;

    return (
            <Helmet
                htmlAttributes={{
                    lang:'EN',
                }}
                title={metaTitle}
                defer={false}
                meta={[
                    {
                        name:"name",
                        content:site.siteMetadata.name
                    },
                    {
                        name: "theme-color",
                        media:"(prefers-color-scheme: light)",
                        content:"#F1534B"
                    },
                    {
                        name: "theme-color",
                        media:"(prefers-color-scheme: dark)",
                        content:"#00928A"
                    },
                    {
                        name: `description`,
                        content: metaDescription,
                    },
                    {
                        name:"canonical",
                        content: "stasercreative.com"
                    },
                    {
                        property: `og:title`,
                        content: metaTitle,
                    },
                    {
                        property: `og:description`,
                        content: metaDescription,
                    },
                    {
                        property: `og:type`,
                        content: `website`,
                    },
                    {
                        name: `twitter:card`,
                        content: `I’m an illustrator and designer who loves
            helping my clients communicate their
            stories through strategic, artful visuals.
            Check out some of my work below!`,
                    },
                    {
                        name: `twitter:creator`,
                        content: site.siteMetadata.author,
                    },
                    {
                        name: `twitter:title`,
                        content: metaTitle,
                    },
                    {
                        name: `twitter:description`,
                        content: metaDescription,
                    },
                    {
                        name:'viewport',
                        content:site.siteMetadata.viewport
                    },
                    {
                        name:'identifier-url',
                        content:site.siteMetadata.identifierUrl
                    },
                    {
                        name:'abstract',
                        content:site.siteMetadata.abstract
                    },
                    {
                        name:'keywords',
                        content:metaKeywords
                    },
                    {
                        name:'author',
                        content:site.siteMetadata.author
                    },
                    {
                        name:'revisit-after',
                        content:site.siteMetadata.revisitAfter
                    },
                    {
                        name:'copyright',
                        content:site.siteMetadata.copyright
                    },
                    {
                        name:'robots',
                        content:site.siteMetadata.robots
                    },
                    {
                        name:'siteUel',
                        content:site.siteMetadata.siteUrl
                    }
                ].concat()}/>
    )
}


export default Seo